
  // Cambiar la clase 'no-js' a 'js' tan pronto como el DOM esté completamente cargado
  document.addEventListener("DOMContentLoaded", function() {
    document.documentElement.className = document.documentElement.className.replace('no-js', 'js');

    // Añadir 'shopify-design-mode' si está en modo diseño
    if (Shopify.designMode) {
      document.documentElement.classList.add('shopify-design-mode');
    }

    // Función para manejar la redirección de WhatsApp
    var whatsappRedirect = function(e) {
      e.preventDefault();
      if (!e.target.classList.contains('closeMessages__button')) {
        var selectedNumber = '+573213603610';
        var whatsAppMessageUrl = 'https://api.whatsapp.com/send?phone=' + selectedNumber + '&text=';

        fetch('//saldosingenio.com/cdn/shop/t/7/assets/emojis.json?v=107075035989410617741789485690')
          .then(function(res) { return res.json(); })
          .then(function(data) {
            var whatsAppDispatcherValues = data;
            var whatsAppOrganicValues = data.organic;
            var whatsAppUtmsValues = data.utms;
            var whatsAppEmoji = whatsAppDispatcherValues.direct || '';

            var queryString = window.location.search.substring(1);
            var urlParams = new URLSearchParams(queryString);
            var utm_source = sessionStorage.getItem("utm_source");
            var utm_medium = sessionStorage.getItem("utm_medium");
            var landingTitle = document.title;

            if (utm_source && utm_medium) {
              var emojiFounded = whatsAppUtmsValues.find(function(item) {
                return item.utm_source.toLowerCase().trim() === utm_source.toLowerCase().trim() &&
                       item.utm_medium.toLowerCase().trim() === utm_medium.toLowerCase().trim();
              });
              if (emojiFounded) {
                whatsAppEmoji = emojiFounded.name.split("-");
              }
            } else if (document.referrer) {
              var referrerEmoji = whatsAppOrganicValues.find(function(item) {
                return document.referrer.toLowerCase().includes(item.source.toLowerCase());
              });
              if (referrerEmoji) {
                whatsAppEmoji = referrerEmoji.name.split("-");
              }
            }

            // Crear el mensaje base de WhatsApp
            var whatsAppBaseMessage = `%C2%A1${whatsAppEmoji}Hola! Vengo de la página: +${encodeURIComponent(landingTitle).replace(/%20/g,"+")}+y quiero recibir asesoría!`;
            window.location.href = whatsAppMessageUrl + whatsAppBaseMessage;
          })
          .catch(function(err) {
            console.error(err);
          });
      }
    };

    // Añadir el evento de clic al botón de WhatsApp
    var whatsappFloatingButton = document.getElementById("whatsAppFloatingButton");
    if (whatsappFloatingButton) {
      whatsappFloatingButton.addEventListener("click", whatsappRedirect);
    }
  });
  